import { DataModel } from "common/models/utility-models/base-model";

export class InternshipDetailsListModel extends DataModel {
    internshipTitle: string = '';
    companyName: string = '';
    // company_name: string = '';
    mentorName: string = '';
    internshipStartDate: string = '';
    internshipEndDate: string = '';
    locName: string = '';
    // location_name: string = '';
    mentorEmail: string = '';
    internshipProjectName: string = '';
    mentorMobile: string = '';  
    // mentorPhone: string = '';  
}